import * as React from 'react';
import {
  useState,
  useMemo,
  useRef,
  useCallback,
} from 'react';
import MapGL, { NavigationControl, Source, Layer } from 'react-map-gl';

import zones from './mapdata/combined-unique.json'
import MapStyles from './lib/MapStyles'


const MAPBOX_TOKEN = 'pk.eyJ1IjoiZW50c29lIiwiYSI6ImNraWhkMnE4NzFyazEyc3JzN3ZtbTJpNmIifQ.onUVeIRBeWYowlTBGTpAVg'; // Set your mapbox token here


const mapStyle = { version: 8, sources: {}, layers: [] };

const styles = MapStyles

function Root(props) {

  const {
    selectedZone 
  } = props

  const ref = useRef(null);
  const [hoveredZoneId, setHoveredZoneId] = useState(null);

  const [viewport, setViewport] = useState({
    latitude: 50.82,
    longitude: 10.054,
    zoom: 2,
    bearing: 0,
    pitch: 0
  });
  

  // Generate two sources (clickable and non-clickable zones), based on the zones data.
  const sources = useMemo(
    () => {
      return {
        zonesClickable: {
          type: 'FeatureCollection',
          features: zones.features.filter((f) => selectedZone === f.properties.id),
        },
        zonesNonClickable: zones,
      };
    },
    [selectedZone]
  );
  // Every time the hovered zone changes, update the hover map layer accordingly.
  const hoverFilter = useMemo(() => (['==', 'id', hoveredZoneId || '']), [hoveredZoneId]);
  // filter to use to hightlight multiple areas
  // const hoverFilter = useMemo(() => (["in",['get', 'id'],['literal', ["10Y1001A1001A44P", "10YFR-RTE------C"]] || '']), [hoveredZoneId]);


  const handleMouseMove = useMemo(
    () => (e) => {
      
        // if (hoveringEnabled) {
        //   onMouseMove({
        //     x: e.point[0],
        //     y: e.point[1],
        //     longitude: e.lngLat[0],
        //     latitude: e.lngLat[1],
        //   });
        // }
        // Ignore zone hovering when dragging (performance optimization).
        // if (!isDragging) {
          const features = ref.current.queryRenderedFeatures(e.point);
          // Trigger onZoneMouseEnter if mouse enters a different
          // zone and onZoneMouseLeave when it leaves all zones.
          
          if (features.length) {
            const { id } = features[0].properties;
            console.log(id)
            if (hoveredZoneId !== id) {
              // onZoneMouseEnter(zones[zoneId], zoneId);
              setHoveredZoneId(id);
            }
          } else if (hoveredZoneId !== null) {
            // onZoneMouseLeave();
            setHoveredZoneId(null);
          }
        // }
    },
    [hoveredZoneId],
  );

  const handleMouseOut = useCallback(() => {
    if (hoveredZoneId !== null) {
      setHoveredZoneId(null);
    }
  }, [hoveredZoneId]);

  return (
    <>
    <div style={{
      padding: '1rem',
      background: '#eee'
    }}>
      {sources.zonesClickable.features.length === 0 ? 'There is currently no matching geo for this area' : `Found ${sources.zonesClickable.features.length} matching geographic feature`}
    </div>
    {sources.zonesClickable.features.length !== 0 && <MapGL
      {...viewport}
      ref={ref}
      width="100%"
      height="90vh"
      mapStyle={mapStyle}
      onMouseMove={handleMouseMove}
      onMouseOut={handleMouseOut}
      onViewportChange={nextViewport => setViewport(nextViewport)}
      mapboxApiAccessToken={MAPBOX_TOKEN}
      // mapOptions={{hash: true}}
    >
      <div
            className="mapboxgl-zoom-controls"
            style={{
              boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.15)',
              position: 'absolute',
              right: '24px',
              top: '24px',
            }}
          >
            <NavigationControl
              showCompass={false}
              zoomInLabel=""
              zoomOutLabel=""
            />
          </div>

        <Layer id="ocean" type="background" paint={styles.ocean} />
        <Source type="geojson" data={sources.zonesNonClickable}>
          <Layer id="zones-static" type="fill" paint={styles.zonesNonClickable} />
          <Layer id="zones-static-line" type="line" paint={styles.zonesNonClickableLine} />
        </Source>
        <Source type="geojson" data={sources.zonesClickable}>
          <Layer id="active-zone" type="fill" paint={styles.zonesClickable} />
        </Source>
        <Source type="geojson" data={sources.zonesNonClickable}>
          <Layer id="hover" type="fill" paint={styles.hover} filter={hoverFilter} />
        </Source>
    </MapGL>}
    </>
  );
}

export default Root;